import { times } from 'lodash';
import { Object3D, Sprite, SpriteMaterial } from 'three';
import { buildCuboidPoints } from '../../../../cross-team-shared/test-helpers/builders/build-cuboid-points-3d';
import { CuboidLocationState3D } from '../../../state/cuboid-location-state-3d';
import { CuboidState3D } from '../../../state/cuboid-state-3d';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import {
  getSideViewRendererLayers,
  setRendererLayers,
} from '../../render-utils';
import {
  ConfigureMeshesConfiguration,
  RenderConfiguration,
} from '../abstract-mesh-helper';
import { highlightColor } from '../color-utils';
import { pixelToOrthographicWorldSize } from '../mesh-utils';

export const cuboidVertexSizePx = 13;
const spriteMaterial = new SpriteMaterial({ color: highlightColor });

export class CuboidVertices extends Object3D {
  private vertices: Sprite[];

  constructor() {
    super();
    this.vertices = times(8).map(() => new Sprite(spriteMaterial));
    this.userData = { meshType: 'vertices' };

    this.vertices.forEach((vertex) => {
      vertex.userData = { meshType: 'vertex' };
      vertex.center.set(0.5, 0.5);
    });

    this.add(...this.vertices);
  }

  dispose() {
    this.vertices.forEach((vertex) => {
      vertex.geometry.dispose();
    });
  }

  setUserData(shapeIndex: number) {
    this.userData.shapeIndex = shapeIndex;
  }

  updateRendererLayers(
    state: PointCloudContentState,
    renderConfig: RenderConfiguration,
    cuboid: CuboidState3D,
  ) {
    const isSelected = cuboid.index in state.render.selection;

    const newEditPanelVisualsLayers =
      !renderConfig.isUsingNewEditPanels ||
      state.readOnly ||
      !isSelected ||
      renderConfig.areCuboidVerticesHidden
        ? []
        : getSideViewRendererLayers();

    setRendererLayers(newEditPanelVisualsLayers, this);
  }

  updatePosition(location: CuboidLocationState3D) {
    const cuboidPoints = buildCuboidPoints(location);

    cuboidPoints.forEach((point, index) => {
      this.vertices[index].position.fromArray(point);
    });
  }

  updateScale(config: ConfigureMeshesConfiguration) {
    if (!getSideViewRendererLayers().includes(config.cameraLayer)) {
      return;
    }

    const vertexScale = pixelToOrthographicWorldSize(
      cuboidVertexSizePx,
      config,
    );

    this.vertices.forEach((vertex) => {
      vertex.scale.set(vertexScale, vertexScale, vertexScale);
    });
  }
}
